import { createFileRoute } from '@tanstack/react-router'
import { requireSection } from '../../../features/settings/guards'
import { PaymentMethodsSection } from '../../../features/settings/payment-methods-section'

export const Route = createFileRoute('/_app/settings/payment-methods')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'payment-methods'),
  component: PaymentMethodsSection,
})
